import { usePointsActivities } from '@/app/components/ReferralPageComponents/hooks/usePointsActivities';
import ReferralEmptyState from '@/app/components/ReferralPageComponents/ReferralEmptyState';
import { useScreenWidth } from '@/app/shared/hooks/useScreenWidth';
import { formatPointsPerDay } from '@/app/shared/lib/formatters';
import PaginatedList from '@/app/shared/ui/PaginatedList';
import { Skeleton } from '@/app/shared/ui/Skeleton';

const DESKTOP_ROW_MIN_WIDTH = 768;

const GetPointsList = () => {
  const { rows, isLoading } = usePointsActivities();
  const screenWidth = useScreenWidth();
  const isDesktop = screenWidth >= DESKTOP_ROW_MIN_WIDTH;
  const itemsPerPage = isDesktop ? 5 : 2;
  const visibleRows = rows.filter((row) => !row.isSocial);

  if (!isLoading && !visibleRows.length) {
    return (
      <div className='mt-2.5 md:mt-10'>
        <ReferralEmptyState
          title='No activities yet'
          description='Point earning activities will appear here once they are available.'
        />
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className='mt-2.5 flex flex-col gap-1.5 md:mt-10'>
        {Array.from({ length: itemsPerPage }, (_, index) => (
          <Skeleton.Line key={index} loading className='h-36.5 md:h-20' />
        ))}
      </div>
    );
  }

  return (
    <div className='mt-2.5 flex flex-col gap-1.5 md:mt-10'>
      <PaginatedList key={itemsPerPage} itemsPerPage={itemsPerPage} className='flex flex-col gap-1.5'>
        {visibleRows.map((item, index) => (
          <a
            key={`${item.campaignKey}-${item.activityName}-${index}`}
            href={item.linkUrl || undefined}
            target={item.linkUrl ? '_blank' : undefined}
            rel={item.linkUrl ? 'noopener noreferrer' : undefined}
            className='flex min-h-36.5 flex-col rounded-md bg-elevated-card-2 p-4 hover:bg-elevated-card-hover md:h-20 md:min-h-0 md:flex-row md:items-center md:justify-between'
          >
            <div className='flex flex-col gap-1'>
              <h3 className='text-base leading-6 font-medium text-gray-200'>{item.activityName}</h3>
              <p className='text-sm text-gray-400'>
                {item.category}
                {item.subcategory ? ` • ${item.subcategory}` : ''}
              </p>
            </div>

            <div className='my-5 h-px w-full bg-gray-700 md:hidden' />

            <div className='flex flex-row items-center justify-between gap-2 md:flex-col md:items-end md:justify-center'>
              <span className='font-medium text-gray-50 md:text-right'>
                {formatPointsPerDay(item.pointsAmount ?? item.pointsPerDay ?? '0')} Points
              </span>
              <span className='text-sm text-gray-400 md:text-right'>/day, per mzUSD</span>
            </div>
          </a>
        ))}
      </PaginatedList>
    </div>
  );
};

export default GetPointsList;
